import { Box, Grid, Tab, Tabs, Typography } from "@mui/material";
import CardView from "../../components/common/CardView";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";

import PageTitle from "../../components/pageTitle/PageTitle";

import {
  getSmsTemplateAction,
  setDeleteSmsTemplateSuccessAction,
} from "../../store/reducers/smsTemplateSlice";
import ManageSmsTemplate from "../components/Communication/smsTemplate/ManageSmsTemplate";
import DeletePopup from "../components/Communication/smsTemplate/DeletePopup";
import ManageSendSmsTemplate from "../components/Communication/smsTemplate/ManageSendSmsTemplate";
import { getLeadStageWithPlaceholdersAction } from "../../store/reducers/emailTemplateSlice";

const SuperAdminSmsTemplate = () => {
  const dispatch = useDispatch();

  const {
    smsTemplates,
    isSmsTemplateResponse,
    isSmsTemplateUpdateSuccess,
    isDeleteSmsTemplateSuccess,
  } = useSelector((state: any) => state.smsTemplate);

  const { leadStageWithPlaceholders } = useSelector(
    (state: any) => state.emailTemplates,
  );

  useEffect(() => {
    if (dispatch) {
      dispatch(getSmsTemplateAction());
      dispatch(getLeadStageWithPlaceholdersAction());
    }
  }, [dispatch]);

  useEffect(() => {
    if (isSmsTemplateResponse || isSmsTemplateUpdateSuccess) {
      dispatch(getSmsTemplateAction());
    }
  }, [dispatch, isSmsTemplateResponse, isSmsTemplateUpdateSuccess]);

  console.log("smsTemplates", smsTemplates);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteModelShow, setDeleteModelShow] = useState(false);
  const [sendModelShow, setSendModelShow] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
    setDeleteModelShow(false);
    setSendModelShow(false);
  };
  const handleEditTemplate = (item: any, category: string) => {
    // Implement your edit functionality here
    console.log("Editing template with ID:", item);
    setSelectedRow({ ...item, category });
    setOpen(true);
    // You can open your edit modal or navigate to edit page here
  };

  const handleDeleteTemplate = (item: any) => {
    setDeleteModelShow(true);
    setSelectedRow(item);
  };

  const [value, setValue] = useState("");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const handleSendTemplate = (item: any) => {
    console.log("Send template with ID:", item);
    setSelectedRow(item);
    setSendModelShow(true);
  };

  useEffect(() => {
    if (isDeleteSmsTemplateSuccess) {
      setSelectedRow(null);
      dispatch(setDeleteSmsTemplateSuccessAction(false));
    }
  }, [dispatch, isDeleteSmsTemplateSuccess]);

  const filteredTemplates = (smsTemplates || []).filter(
    (x: any) => x?.lead_stage === value,
  );

   const sortedStages = useMemo(() => {
    return [...(leadStageWithPlaceholders || [])].sort(
      (a: any, b: any) => a.stage_order - b.stage_order
    );
  }, [leadStageWithPlaceholders]);

  useEffect(() => {
    if (!sortedStages.length) return;

    const hasSelectedStage = sortedStages.some((stage: any) => stage.stage === value);
    if (!hasSelectedStage) {
      setValue(sortedStages[0].stage);
    }
  }, [sortedStages, value]);

  return (
    <>
      {deleteModelShow && (
        <DeletePopup
          deleteModalShow={deleteModelShow}
          onHide={handleClose}
          deleteRec={selectedRow}
          setDeleteModalShow={setDeleteModelShow}
        />
      )}
      {open && (
        <ManageSmsTemplate
          selectTemplate={selectedRow}
          setSelectedRow={setSelectedRow}
          open={open}
          onHide={handleClose}
          title={selectedRow ? "Edit SMS Template" : "Add SMS Template"}
        />
      )}
      {sendModelShow && (
        <ManageSendSmsTemplate
          selectTemplate={selectedRow}
          setSelectedRow={setSelectedRow}
          open={sendModelShow}
          onHide={handleClose}
          title={"Send SMS Template"}
          screenType={value === "0" ? "ADMIN" : "CLIENT"}
        />
      )}
      <Grid
        container
        rowSpacing={1}
        // columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        sx={{
          background: "#f4f4f4",
          height: "auto",
          padding: "10px",
          // flexDirection: { xs: "column", md: "row" },
        }}
      >
        <Box
          // fixed={true}
          sx={{
            bgcolor: "#fff",
            padding: "20px 0px",
            border: "1px solid #d1cfcf",
            borderRadius: "5px",
            height: "fit-content",
            width: "100%",
          }}
        >
          <PageTitle
            title="SMS Template"
            button="Add SMS Template"
            onClick={handleOpen}
          />

          <Grid
            container
            // wrap="nowrap"
            spacing={2}
            sx={{
              flexDirection: { xs: "column", md: "row" },
              marginTop: "10px",
              padding: "16px 20px",
            }}
          >
            <Grid
              item
              xs={12}
              md={12}
              style={{ padding: "0px 10px", marginBottom: "10px" }}
            >
              <Tabs
                // centered
                value={value}
                onChange={handleChange}
                textColor="secondary"
                indicatorColor="secondary"
                aria-label="secondary tabs example"
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                sx={{
                  background: "#fff",
                  fontSize: "14px",
                  fontWeight: 600,
                  marginBottom: "16px",
                  overflowX: "auto",
                  whiteSpace: "nowrap",
                  minWidth: 0,
                  '& .MuiTabs-flexContainer': {
                    flexWrap: 'nowrap',
                  },
                }}
              >
                {sortedStages.length > 0 &&
                  sortedStages.map((item: any, index: number) => (
                    <Tab
                      key={index}
                      value={item.stage}
                      label={item.description}
                    />
                  ))}
                {/* <Tab value="0" label="Admin" />
                <Tab value="1" label="Client" /> */}
              </Tabs>
            </Grid>
            {filteredTemplates.length > 0 ? (
              filteredTemplates?.filter((item: any) => item?.template_from === "client")?.map((item: any, i: number) => (
                <Grid
                  key={i}
                  item
                  xs={12}
                  md={3}
                  style={{ padding: "0px 10px", marginBottom: "10px" }}
                >
                  <>
                    <CardView
                      {...{
                        ...item,
                        isEdit: true,
                        isDelete: true,
                        isSend: true,
                        width: "100%",
                        onEditClick: () => handleEditTemplate(item, "admin"),
                        onDeleteClick: () => handleDeleteTemplate(item),
                        onSendClick: () => handleSendTemplate(item),
                      }}
                    />
                  </>
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "300px",
                    border: "1px dashed #ccc",
                    borderRadius: "12px",
                    backgroundColor: "#fafafa",
                    textAlign: "center",
                    p: 3,
                  }}
                >
                  {/* Icon */}
                  <Box
                    sx={{
                      width: 70,
                      height: 70,
                      borderRadius: "50%",
                      backgroundColor: "#e0f2f1",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 2,
                    }}
                  >
                    📧
                  </Box>

                  {/* Title */}
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, color: "#333", mb: 1 }}
                  >
                    No SMS Templates Found
                  </Typography>

                  {/* Subtitle */}
                  <Typography
                    variant="body2"
                    sx={{ color: "#777", maxWidth: "300px", mb: 2 }}
                  >
                    You haven't created any SMS templates yet. Start by
                    creating a new template.
                  </Typography>
                </Box>
              </Grid>
            )}
          </Grid>
          {/* </Box> */}
        </Box>
      </Grid>
    </>
  );
};
export default SuperAdminSmsTemplate;
